module.exports = __webpack_public_path__ + "images/img-2laU9If.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/leads.jpg
// module id = 1998
// module chunks = 0